<template>
  <p :class="$style.root">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'BaseWarning'
};
</script>

<style lang="less" module>
.root {
  font-size: 14px;
  color: #ec7e00;
  line-height: 18px;
  padding-left: 21px;
  background-image: url(~@static/i/blocks/warning/icon.svg);
  background-repeat: no-repeat;
  background-size: 16px 14px;
  background-position: left 2px;
  margin-top: 10px;
  margin-bottom: 0;
}
</style>

<i18n lang="json">{}</i18n>
